module.exports = __webpack_public_path__ + "static/media/mysql.7998bd40.svg";